module.exports = __webpack_public_path__ + "static/media/ai.dcb9035d.png";